import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { actionTypes } from '../actions/login.actions'

const initialAuthState = {
  token: undefined,
  email: undefined,
  iduser: undefined,
  name: undefined,
  roles: [],
  rolesPermitted: [],
  signUpAt: undefined,
  locale: 'es_ES',
  dashboard: undefined,
  firstAccess: undefined,
}

const config = {
  storage,
  key: 'pontio',
  whitelist: ['iduser', 'email', 'name', 'roles', 'rolesPermitted', 'signUpAt', 'locale', 'dashboard', 'firstAccess'],
}

const reducer = persistReducer(config, (state = initialAuthState, action) => {
  switch (action.type) {
    case actionTypes.login: {
      return { ...action.payload }
    }

    case actionTypes.logout: {
      return initialAuthState
    }

    case actionTypes.locale: {
      return { ...state, locale: action.payload }
    }
    case actionTypes.change: {
      return { ...action.payload }
    }
    case actionTypes.changeFirstAccess: {
      return { ...state, firstAccess: action.payload }
    }
    default:
      return state
  }
})

export default reducer
